// Test: Direct Mercury app change - round 3 - should trigger Mercury release only
import React from 'react';
import ReactDOM from 'react-dom';
import config from 'config';
import { DRAWER_REGION_ID_RIGHT, DRAWER_REGION_ID_LEFT } from '@ontruck/fe-ui';
import { intlConfig, locales } from './intl/settings';
import { configureIntl } from './intl/config';
import { configureStore } from 'redux/store';

import { App } from 'containers/App';
import Root from 'containers/Root';
import { localStorage } from 'utils/storage';
import { init as initAuth } from 'utils/auth';
import { init as initConverters } from 'utils/converters';
import 'containers/App/global-styles.scss';
import 'react-phone-number-input/style.css';
import { initSentry } from 'modules/sentry';
import { requestNotificationsPermission } from 'utils/notifications';

requestNotificationsPermission();

// Mercury app: Independent version test - round 2
// This change should only trigger Mercury's version bump
const getStored = (key) => {
  const val = localStorage.getItem(key);
  return (val && val !== 'undefined' && JSON.parse(val)) || null;
};

const user = getStored('mercuryUser');
const options = {
  userLocale: user?.country_settings?.locale,
  defaultLocale: 'es',
};
const initialState = {
  user: user || null,
  intl: configureIntl(intlConfig, locales, options),
};

// Exporting the store is something we really shouldn't need
// However, our utils/auth class needs access to the store
// quite far down the chain. Sorry future selves!
const store = configureStore(initialState);

initSentry(config.SENTRY_DSN);
initAuth(store);
initConverters(store);

ReactDOM.render(
  <>
    <aside id={DRAWER_REGION_ID_LEFT}></aside>
    <Root store={store}>
      <App />
    </Root>{' '}
    <aside id={DRAWER_REGION_ID_RIGHT}></aside>
  </>,
  document.getElementById('root')
);

// registerServiceWorker();
